/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, FUNCTIONS){
	const a = 'is-active';
	let lang = location.pathname.split('/')[1];
	if(location.pathname.split('/')[1] === 'global') {
		lang = 'glo';
	}
	const technologyDetailJson = () => {
		if($('.js-technology-detail-jsonWrap').length) {
			const getJSONtechnologyDetail = (_category,_detail) => {
				return $.getJSON(`/ajax/${lang}/technology/detail/${_category}/${_detail}.json`);
			};
			getJSONtechnologyDetail($('.js-technology-detail-jsonWrap').find('.rt_cf_n_category_code').text(),$('.js-technology-detail-jsonWrap').find('.rt_cf_n_news_id').text()).done((data) => {
				if(!data.rt_bn_technical_theme_details_list.length) {
					$('.js-technology-detail-jsonWrap').addClass('di_none');
				} else {
					let HTML = '';
					for (let l = 0; l < data.rt_bn_technical_theme_details_list.length; l++) {
						// console.log(data.rt_bn_technical_theme_details_list[l]);
						HTML += '<li class="pure-u-1-4 pure-u-lg-1-1 space-u-32-child space-md-24-child">'+
						'<a href="'+data.rt_bn_technical_theme_details_list[l].rt_cf_n_href.href+'" class="mod-textLink01">'+
						'<span class="mod-head04">'+data.rt_bn_technical_theme_details_list[l].rt_cf_n_title.content+'</span>'+
						'<svg class=""><use xlink:href="/common/svg/sprite.svg#arrow_right" /></svg></a></li>';
					}
					$('.js-technology-detail-json').append(HTML);
				}
			});
		}
	}
	technologyDetailJson();
})(window.jQuery, window.FUNCTIONS);
